var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderOpen = function SvgOrderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.22 11.925a1.98 1.98 0 0 1-1.741 1.025H9.065l-1.094 1.99h11.94v1.992H7.972c-1.513 0-2.468-1.623-1.742-2.957l1.343-2.429L3.99 3.991H2V2h3.254l.935 1.99h14.728a.992.992 0 0 1 .865 1.474l-3.562 6.46Zm1.005-5.943H7.135l2.358 4.977h6.986l2.746-4.977ZM5.99 19.918c0-1.095.886-1.99 1.98-1.99 1.095 0 1.99.895 1.99 1.99s-.895 1.991-1.99 1.991a1.988 1.988 0 0 1-1.98-1.99Zm9.951 0c0-1.095.886-1.99 1.98-1.99 1.095 0 1.99.895 1.99 1.99s-.895 1.991-1.99 1.991a1.988 1.988 0 0 1-1.98-1.99Zm-4.67-11.842 1.14 1.141 2.833-2.725.589.672-1.597 1.597-1.825 1.825-1.825-1.825.684-.685Z",
    fill: "#000",
    fillOpacity: 0.87
  })));
};
export default SvgOrderOpen;